export default __webpack_public_path__ + "static/media/варежка.77492a29.jpg";